import {StudyContent} from '@cp/model';
import {env} from '../../../../config/env';
import splitStringMulti from '../../../../utils/string/splitStringMulti';

export default function splitContentToStudyContent(content: string): StudyContent[] {
  if (!content || !content.trim()) {
    return [];
  }

  // Split by "## " at the start of lines (not "###")
  // Use regex that matches "## " followed by a non-# character
  const sections = splitStringMulti(content, /^## [^#]/m);

  if (sections.length === 0) {
    return [];
  }

  return sections.map((section) => {
    const lines = section.split(/\r?\n/);
    const titleLine = lines[0] || '';

    // Extract title from header line (remove "## ")
    const title = titleLine.startsWith(env.study.separator)
      ? titleLine.substring(env.study.separator.length).trim()
      : '';

    // Get content lines (everything after the header line)
    const contentLines = lines.slice(1); // skip the first line (title)

    let sectionContent = contentLines.join('\n');

    // Remove leading newlines
    // sectionContent = sectionContent.replace(/^\n+/, '');

    // For sections that aren't the last, reconstruction adds \n\n as separator
    // Remove exactly 2 trailing newlines if present (the separator)
    // if (sectionIndex < sections.length - 1) {
    //   if (sectionContent.endsWith('\n\n')) {
    //     sectionContent = sectionContent.slice(0, -2);
    //   }
    // }

    return {
      title,
      content: sectionContent,
    };
  });
}
